module.exports = __webpack_public_path__ + "img/noPermission.cf17a8ea.svg";